<!--协同备课学科统计图-->
<template>
    <div class="my-charts">
        <div :id="id" style="margin-top: -40px;"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";


export default {
    name: "teaWorkAgeEchart",
    props: {
        id:{
            type: String,
            default:"tea_work_age_echart"
        },
        itemList:{
            type: Array,
            default:[]
        },
        countList:{
            type: Array,
            default:[]
        },
    },
    watch:{},
    data() {
        return {
            barChart: null, // 柱状图
            chartOption:{
                title: {
                    text: '',
                    left: 'center',
                    top: 10,
                },
                tooltip: {
                    trigger: 'item'
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        show: true,
                        interval:0,
                        rotate:0,
                        textStyle: {    //文字样式
                            color: "black",
                            fontSize: 6,
                        }
                    },
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        show: true,
                        textStyle: {    //文字样式
                            color: "black",
                            fontSize: 12,
                        }
                    },
                },
                series: [
                    {
                        data: [],
                        type: 'bar',
                        color: [
                            '#5087ec',
                        ],
                        barMaxWidth: 50,
                        showBackground: true,
                        barCategoryGap: '10',
                        backgroundStyle: {
                            color: 'rgba(180, 180, 180, 0.2)'
                        }
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            this.barChart = echarts.init(document.getElementById(this.id));
            this.chartOption.series[0].data = []
            this.chartOption.series[0].data = this.countList;
            this.chartOption.xAxis.data = []
            this.chartOption.xAxis.data = this.itemList
            this.barChart.setOption(this.chartOption);
        }
    }
};
</script>


<style scoped lang="scss">
.my-charts {
    width: 100%;
    height: calc(50vh - 100px);
    flex-direction: column;
    div {
        width: 100%!important;
        height: calc(50vh - 50px);
    }
}
</style>